import { ContractViewModel, ProductComponent, ServiceKind, ServiceViewModel } from '@ail/contracts-api'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../hooks/useAuth'
import { activeServicesIconsDict } from '../../../types/constants'
import { Arr } from '../../../helpers/Arr'

export function ActiveServiceDetails(props: { contract?: ContractViewModel }) {
  const { user } = useAuth()
  const { t } = useTranslation('common')

  const getServiceLabel = useCallback(
    (service: ServiceViewModel) => {
      switch (service.product) {
        case ProductComponent.KaskoHandling:
          return t('KASKO')
        case ProductComponent.LiabilityHandling:
          return t('LIABILITY')
        default:
          return t(service.kind.toUpperCase())
      }
    },
    [t]
  )

  const fuelCards = useMemo(() => {
    return props.contract?.services?.filter((s) => s.kind === ServiceKind.Fuel) ?? []
  }, [props.contract])

  const uniqueServices = useMemo(() => {
    const result: ServiceViewModel[] = []

    const fuelService = props.contract?.services?.find(
      (s) => s.kind === ServiceKind.Fuel && s.name?.toLowerCase() === 'treibstoff'
    )
    if (fuelService) {
      result.push(fuelService)
    }

    let kaskoService = props.contract?.services?.find((s) => s.kind === ServiceKind.AilKasko)
    if (!kaskoService) {
      kaskoService = props.contract?.services?.find(
        (s) => s.kind === ServiceKind.Kasko && s.name === 'Kasko_extern' && s.leasePrice > 0
      )
    }
    if (!kaskoService) {
      kaskoService = props.contract?.services?.find(
        (s) => s.kind === ServiceKind.Fee && s.product === ProductComponent.KaskoHandling
      )
    }
    if (kaskoService) {
      result.push(kaskoService)
    }

    let liabilityService = props.contract?.services?.find(
      (s) => s.kind === ServiceKind.Fee && s.product === ProductComponent.LiabilityHandling
    )
    if (!liabilityService) {
      liabilityService = props.contract?.services?.find((s) => s.kind === ServiceKind.Liability)
    }
    if (liabilityService) {
      result.push(liabilityService)
    }

    for (const service of props.contract?.services ?? []) {
      if (!activeServicesIconsDict[service.kind] && !activeServicesIconsDict[service.product]) {
        continue
      }
      if (
        service.kind === ServiceKind.AilKasko ||
        service.kind === ServiceKind.Kasko ||
        service.kind === ServiceKind.Fee ||
        service.kind === ServiceKind.Liability ||
        service.product === ProductComponent.KaskoHandling ||
        service.product === ProductComponent.LiabilityHandling ||
        result.some((s) => s.kind === service.kind)
      ) {
        continue
      }
      result.push(service)
    }

    return Arr.sort(result, (s) => getServiceLabel(s))
  }, [getServiceLabel, props.contract?.services])

  return (
    <div className="detailContentArea activeServices">
      <div className="detailTitle eyeOk">
        <i className="icon-contract" /> <span>Active services</span>
      </div>
      <div className={`details ${!!fuelCards.length && user?.isInternalUser ? 'serviceSliderArea' : ''}`}>
        <ul className="activeServices">
          {uniqueServices.map((el, i) => (
            <li key={i}>
              <span className="tooltipText">{el.name}</span>
              <i className={activeServicesIconsDict[el.kind] || activeServicesIconsDict[el.product] || 'icon-4u'}></i>
              {getServiceLabel(el)}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
